import * as React from 'react';
import { Transition } from 'react-transition-group';

import { styles } from './styles';
import { animations } from './animations';
import { TransitionProps } from 'react-transition-group/Transition';
import { cx } from 'emotion';
import { ANIMATION_DURATION_MS } from '@joykit/variables/animations';

export type Direction = 'top' | 'bottom';
export type As = 'state' | 'css';
export type Position = 'absolute' | 'relative';
export interface BaseProps {
  children: React.ReactNode;
  as: As;
  className?: string;
  in?: boolean;
  from: Direction;
  to: Direction;
  appear?: boolean;
  onExited?: TransitionProps['onExited'];
  onEntered?: TransitionProps['onEntered'];
  timeout: TransitionProps['timeout'];
  enter?: TransitionProps['enter'];
  exit?: TransitionProps['exit'];
  mountOnEnter?: TransitionProps['mountOnEnter'];
  unmountOnExit?: TransitionProps['unmountOnExit'];
  addEndListener?: TransitionProps['addEndListener'];
  position: Position;
}

export type Props = BaseProps;

class SlideInVertical extends React.Component<Props> {
  hasEntered = false;

  static defaultProps = {
    as: 'state' as As,
    from: 'bottom' as Direction,
    to: 'top' as Direction,
    position: 'relative',
    timeout: {
      enter: ANIMATION_DURATION_MS,
      exit: ANIMATION_DURATION_MS
    }
  };

  render() {
    const {
      from,
      in: inProp,
      as: asProp,
      appear,
      addEndListener,
      children,
      timeout,
      position,
      className,
      unmountOnExit,
      mountOnEnter,
      onEntered
    } = this.props;
    if (asProp === 'css') {
      return <div className={cx(styles.container(from, position), className)}>{children}</div>;
    }
    const animationStates = animations.getAnimationStates(from);

    return (
      <Transition
        in={inProp}
        appear={appear}
        enter={this.props.enter}
        onEnter={node => node.scrollTop}
        onEntered={onEntered}
        onExiting={node => {
          node.addEventListener('transitionend', () => {
            console.log('yeet');
          });
        }}
        exit={this.props.exit}
        timeout={timeout || ANIMATION_DURATION_MS}
        mountOnEnter={mountOnEnter}
        unmountOnExit={unmountOnExit}
        addEndListener={addEndListener}
        onExited={node => {
          if (this.props.onExited) {
            this.props.onExited(node);
          }
        }}
      >
        {state => {
          return (
            <div className={cx(styles.container(from, position, state), className)} style={animationStates[state]}>
              {children}
            </div>
          );
        }}
      </Transition>
    );
  }
}

export { SlideInVertical };
